<template>
    <vs-popup classContent="popup-example"  title="ویرایش اطلاعات تماس با ما" :active.sync="showPopup">
        <div @keydown.enter="editContactUsInfo()">
            <div class="vx-row">
                <div class="vx-col w-3/4 mt-4">
                    <label class="vs-input--label">آدرس</label>
                    <vs-textarea v-model="contactUs.address" />
                </div>
                <div class="vx-col w-1/4 mt-4">
                    <label class="vs-input--label">ایمیل</label>
                    <vs-input v-model="contactUs.email" />
                </div>
            </div>

            <vs-divider />
            <h6>لینک شبکه های اجتماعی</h6>

            <vs-row vs-w="12">
                <vs-col vs-w="3" class="mt-4">
                    <label class="vs-input--label">فیسبوک</label>
                    <vs-input v-model="contactUs.facebook" />
                </vs-col>
                <vs-col vs-w="3" class="mt-4">
                    <label class="vs-input--label">اینستاگرام</label>
                    <vs-input v-model="contactUs.instagram" />
                </vs-col>
                <vs-col vs-w="3" class="mt-4">
                    <label class="vs-input--label">لینکدین</label>
                    <vs-input v-model="contactUs.linkedin" />
                </vs-col>
                <vs-col vs-w="3" class="mt-4">
                    <label class="vs-input--label">تلگرام</label>
                    <vs-input v-model="contactUs.telegram" />
                </vs-col>
                <vs-col vs-w="3" class="mt-4">
                    <label class="vs-input--label">توییتر</label>
                    <vs-input v-model="contactUs.twitter" />
                </vs-col>
            </vs-row>

            <vs-divider />
            <h6>تلفن های تماس</h6>

            <div class="vx-row">
                <div class="vx-col w-1/4" v-for="(item, index) in phone" :key="index">
                    <vs-input v-model="newPhone[index]" class="mt-4" />
                </div>
            </div>

            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <vs-button class="mr-3 mb-2 float-right" @click="editContactUsInfo()">ثبت</vs-button>
                </div>
            </div>
        </div>
    
    </vs-popup>
</template>

<script>
export default {
    name: 'EditContactUs',

    props: {
        popupEditContactUs: {
            type: Boolean,
            default: false,
        },
        ContactUsId: Number
    },
    
    components: {
    },
    
    data() {
		return{
            showPopup: false,
            contactUs: {
                address: '',
                email: '',
                facebook: '',
                instagram: '',
                linkedin: '',
                telegram: '',
                twitter: '',
                phone: ''
            },
            phone: [],
            newPhone: [],
		}
    },
    
    computed: {
    },

    watch: {
      	popupEditContactUs(newVal) {
            this.showPopup = newVal
            this.phone = []
            if(newVal == true){
                this.$vs.loading()
                this.$store.dispatch('getPosts', 'contact/json')
                .then(res => {
                    localStorage.setItem('postId', this.ContactUsId)
                    this.contactUs = res.data[0].text
                    let phone = ''
                    if(this.contactUs.phone != null) {
                        phone = this.contactUs.phone.split(',')
                    }
                    phone.forEach(num => {
                        this.phone.push(num)
                    });
                    this.newPhone = this.phone
                    this.$vs.loading.close()
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupEditContactUs', newVal)
        },
    },

    created(){	
    },
    
    methods: {
        editContactUsInfo() {
            this.$vs.loading()
            
            this.contactUs.phone = this.newPhone.toString();
            let text = JSON.stringify(this.contactUs);

            let formData = new FormData();
            formData.append('title', 'تماس با ما');
            formData.append('text', text);
            formData.append('order', 0);
            formData.append('type', 'contact');
            this.$emit('updatePopupEditContactUs', false, text)
            this.$store.dispatch('updatePostInfo', formData)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'اطلاعات تماس با موفقیت ویرایش شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات ارسالی صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
        }
    }
}
</script>

<style scope>
.con-vs-popup .vs-popup {
    width: 70% !important;
}
</style>